/* eslint-disable no-unused-vars */
import type { TItemType } from '@modules/items/types/items.types';

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/common/access/schemas/access.schema.ts
export enum AccessType {
  NONE = 0,
  PARTIAL = 100,
  READ = 200,
  EDIT = 300,
  MANAGE = 400,
}

export enum AccessTypeString {
  NONE = '0',
  PARTIAL = '100',
  READ = '200',
  EDIT = '300',
  MANAGE = '400',
}

export type TAccessNodeType = TItemType | 'CHANGE_TEMPLATE';

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/common/access/types/access.types.ts
export type TAccessContainerType = 'FOLDER' | 'CHANGE_TEMPLATE';

export type UserAccessEntry = {
  user: string;
  accessType: AccessType;
};

export type TAccessInfo = {
  users: UserAccessEntry[];
  totalUsers: UserAccessEntry[];
  totalUsersParent: UserAccessEntry[];
};

export type TPermissions = {
  token: string;
  accessRight: AccessType;
};

export type TAccessDialogState = {
  isOpen: boolean;
  id: string;
  nodeType: TAccessNodeType;
  name: string;
};
